import { NgModule } from '@angular/core';
import { NgModel } from "@angular/forms";
import { RouterModule, Routes } from '@angular/router';
import { ListComponent } from './list/list.component';
import { ProductUpdateComponent } from './product-update/product-update.component';
const routes: Routes = [{
    path:'',
    component: ListComponent
  },{
    path:':id',
    component:ProductUpdateComponent
  }];
  
@NgModule({
    imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProductsRoutingModule{}